import { useHistory } from "react-router-dom";
import { useAutoUpdateNextYearHolidaysMutation, useHolidaysQuery } from "../../Generated/graphql";
import { Button } from "../Button/Button";
import "./SuperAdminHolidays.css";
import { SuperAdminHolidaysList } from "./SuperAdminHolidaysList/SuperAdminHolidaysList";

export const SuperAdminHolidays = () => {
  const { data, error, loading, refetch } = useHolidaysQuery();
  const [autoUpdateNextYearHolidays, { loading: updating }] = useAutoUpdateNextYearHolidaysMutation();
  const history = useHistory();

  const handleAutoUpdate = async () => {
    try {
      await autoUpdateNextYearHolidays();
      refetch();
    } catch (error) {
      console.error('Failed to update holidays:', error);
    }
  };
  return (
    <div className="SuperAdminHolidays">
      <div className="SuperAdminHolidays__header">
        <div className="SuperAdminHolidays__title">
          <div className="SuperAdminHolidays__title-text">Helligdage</div>
        </div>
        <div className="Settings__dividerbar"></div>
        <div className="SuperAdmin__newholiday">
          <Button
            buttonStyle="newItem"
            click={() => {
              history.push("/superadmin/holidays/new");
            }}
          >
            Tilføj helligdag
          </Button>
          <Button
            buttonStyle="newItem"
            click={handleAutoUpdate}
            inactive={updating}
          >
            {updating ? 'Opdaterer...' : 'Opdater næste års helligdage'}
          </Button>
        </div>
      </div>

      <div className="SuperAdminHolidays__content">
        {loading && <h1>Loading...</h1>}
        {error && <h1>Error... {error.message}</h1>}
        {data && (
          <div>
            <SuperAdminHolidaysList holidays={data?.holidays ?? []} />
          </div>
        )}
      </div>
    </div>
  );
};
